import React, { useContext } from "react";
import { Table } from "antd";
import TableContext from "../tableContext";
import Header from "./header";
import useSearch from "../logics/search";

const DataTable = () => {
  const { props, columns, loading } = useContext(TableContext);
  const dataSource = useSearch();

  return (
    <>
      <Header />
      <Table
        {...props}
        columns={columns}
        dataSource={dataSource}
        loading={loading}
        onChange={(e) => {
          props.onChange && props.onChange(e);
          window.scrollTo({ top: 0, behavior: "smooth" });
        }}
      />
    </>
  );
};

export default DataTable;
